import { Controller } from "react-hook-form"
import { Field, Textarea } from "@chakra-ui/react"

export default function TextAreaInput({ control, rules, name, value, label, help }) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={value || ""}
            rules={rules}
            render={({ field, fieldState: { error } }) => {
                return (
                    <Field.Root invalid={!!error}>
                        <Field.Label htmlFor={name}>{label}</Field.Label>
                        <Textarea {...field} />
                        {help && <Field.HelperText>{help}</Field.HelperText>}
                        {error && <Field.ErrorText>{error.message}</Field.ErrorText>}
                    </Field.Root>
                )
            }}
        />
    )
}
